export default __webpack_public_path__ + "static/media/shapes.db00a546.png";